export default __webpack_public_path__ + "static/media/Tick.f049d8b5.svg";